import {init3DLink} from './init3DLink';
import {initLightboxes} from './initLightboxes';
import {initPointer} from './initPointer';
import {initScrollToFinishing} from './initScrollToFinishing';
import {initSlider} from './initSlider';
import {initSummary} from './initSummary';
import {initTip} from './initTip';

const initApartment = () => {
	const apartmentCard = document.querySelector( 'article.cds2-apartment-card' );

	if ( !apartmentCard )
	{
		return;
	}

	init3DLink( apartmentCard );
	initLightboxes( apartmentCard );
	initPointer( apartmentCard );
	initScrollToFinishing( apartmentCard );
	initSlider( apartmentCard.querySelector( 'div.apartment-slider' ) );
	initSummary( apartmentCard );
	initTip( apartmentCard );
};

export const initApartmentCard = () => {
	initApartment();

	document.addEventListener( 'click', ( evt ) => {
		if ( evt.target.classList.contains( 'toggle-furniture' ) || ( evt.target.classList.contains( 'descriptions' ) && window.innerWidth < 1024 ) )
		{
			evt.target.closest( 'div.apartment-slider' ).querySelector( 'ul.slides li.layout svg' ).classList.toggle( 'furniture-hidden' );

			if ( document.querySelector( 'button.toggle-furniture' ) )
			{
				evt.target.classList.toggle( 'show' );
			}
		}
	} );

	document.addEventListener( 'change', ( evt ) => {
		if ( !evt.target.dataset.guid )
		{
			return;
		}

		const requestedApartment = evt.target.dataset.guid;
		const url = `/choose/apartments/${requestedApartment}/`;

		location.href = url;
	} );
};
